import CheckoutOverlay from '../../../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import SezzleOverlayLazyLoader from './SezzleOverlayLazyLoader';

function SezzleOverlay() {
  return (
    <CheckoutOverlay
      popup
      nopadding
      fullscreenMobile
    >
      <SezzleOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

export default SezzleOverlay;
